module.exports = __webpack_public_path__ + "img/11.8ad07e15.png";